import { render, staticRenderFns } from "./PostsShow.vue?vue&type=template&id=e9cc3574"
import script from "./PostsShow.vue?vue&type=script&lang=js"
export * from "./PostsShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports